export interface SaveStructure {
    transactionType: TransactionType; 
    row: any;
}

export enum TransactionType {
    update = 1,
    insert = 2,
    delete = 3,
}